<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'意见反馈管理'},{name:'意见反馈列表',goback:true},{name:'意见反馈详情'}]" :title="'意见反馈详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="反馈信息" shadow="never">
                 <el-row>
                  <el-col :span="24">
                    <div class="child">
                        <div class="name">意见描述：</div>
                        <div class="content">{{detail.opExplain || '--'}}</div>
                    </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">问题分类：</div>
                        <div class="content">{{detail.opinionType === 1?'建议':detail.opinionType === 2?'问题':''}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{detail.issueAccount || '--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系电话：</div>
                        <div class="content">{{detail.phone || '--'}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">提交时间：</div>
                        <div class="content">{{detail.createTime || '--'}}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              
               <el-card class="basic box_card mt16" header="处理结果" shadow="never" v-if="detail.disposeStatus">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">处理账号：</div>
                              <div class="content">{{detail.disposeAccount || '--'}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">处理时间：</div>
                            <div class="content">{{detail.disposeTime || '--'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">处理描述：</div>
                            <div class="content">{{detail.disposeExplain || '--'}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{
              id: void 0,
              opExplain: ''
            },//数据
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/opinion/findOpinionDetails/'+this.id)
          if (code == 200) {            
              this.detail = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
       const {id} = this.$route.params
        this.id=id;
        if(id) this.getData()
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
     overflow: hidden;
}
.box{
    height:95%;
     overflow-x: hidden;
     overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>